import React from 'react';


interface CustomTextWrapperProps {
    dangerouslySetInnerHTML?: any;
}

const CustomTextWrapper: React.SFC<CustomTextWrapperProps> = ({ dangerouslySetInnerHTML, ...props }) => (dangerouslySetInnerHTML ? (
    <span dangerouslySetInnerHTML={dangerouslySetInnerHTML} {...props} />
)
    : (
        <React.Fragment {...props} />
    ));

export { CustomTextWrapper };
